const sfPathnamePagingRegex = /(\/[0-9][0-9]*\/?)$/gi

const indexCatalogueKey = 'indexCatalogue'

let hasActiveFiltering = (location) => {
    const url = new URL(location || window.location)
    return url.searchParams.has(indexCatalogueKey)
}

const useBaseSearch = () => {

    const optionLabelKey = 'Title'
    const optionValueKey = 'Name'
    const optionChildrenKey = 'Subtaxa'

    const getSearchParams = () => new URLSearchParams(window.location.search)

    let filterChildren = (taxa, items) => {
        let filteredItems = new Set(items)
        taxa.forEach(option => {
            if (items.has(option[optionValueKey])) {
                option[optionChildrenKey].forEach(child => {
                    filteredItems.delete(child[optionValueKey])
                })
            }
        })
        return filteredItems
    }

    const objectByValueKeys = (keys, taxa) => {
        let objects = new Set()

        taxa.forEach(option => {
            if (keys.has(option[optionValueKey])) {
                objects.add(option)
            }
        })

        //todo handle recursive structures someday
        return objects;
    }

    const findSearchResultsContainer = () => {
        return document.querySelector('[data-dynamic-search-container]')
    }

    return {
        optionLabelKey,
        optionValueKey,
        optionChildrenKey,
        getSearchParams,
        filterChildren,
        objectByValueKeys,
        findSearchResultsContainer
    }
}

export default {
    sfPathnamePagingRegex,
    hasActiveFiltering,
    indexCatalogueKey,
    useBaseSearch
}

